import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { User } from '../../model/User';
import { MessageService } from '../service-ui/message.service';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { StartupService } from '../service-ui/startup.service';
import {environment} from "../../environments/environment";
import {DataService} from "./data-service";
import {Facility} from "../../model/Facility";
import {PrintNodeOrder} from "../../model/PrintNodeOrder";

@Injectable()
export class ShippingService extends DataService {

  constructor(private http: HttpClient, private messageService: MessageService, private startupService: StartupService) {
    super(startupService);
    // this.startupService.setUserService(this);
  }

  /**
   * PUT: createShippingLabels for a PrintNodeOrder.
   *
   * `shippingCarrierAndService` is a URL path segment of the form
   * `CARRIER_SERVICELEVEL` (e.g. `USPS_PRIORITY`) that the server
   * historically applied to EVERY package in the order regardless
   * of the package's own `carrier` / `servicelevel` columns.
   *
   * Sentinel value `PER_PACKAGE` (no underscore) instructs the
   * server to use each package's own `carrier` + `servicelevel`
   * when generating that package's shipping label. This is now the
   * default the UI sends — the print button no longer forces the
   * whole-order carrier/service onto every package, so per-package
   * overrides made via `ChangePackages` (different carriers /
   * service levels for individual packages within a single
   * PrintNodeOrder) are honoured when the labels get generated
   * (bug 2026-07-20).
   *
   * Callers that legitimately WANT to force a single carrier +
   * service across every package (bulk relabel to a different
   * carrier as an operator override) can still pass an explicit
   * `CARRIER_SERVICELEVEL` string.
   *
   * Server contract: see the outbox note
   * `docs/contracts/outbox/2026-07-20-shippinglabel-per-package-carrier.md`.
   */
  createShippingLabels(facility: Facility, printNodeOrder: PrintNodeOrder, shippingCarrierAndService, printer: string ): Observable<User> {
    const url = `${environment.apiBaseURL}shippinglabel/${facility.ID}/${printNodeOrder.ID}/${shippingCarrierAndService}/${printer}`;
    this.messageService.add(`ShippingService: createShippingLabel facility printNodeOrder id=${facility.ID} ${printNodeOrder.ID}`);
    return this.http.put(url, undefined, this.startupService.getHttpOptions()).pipe(
      tap(_ => this.log(`createShippingLabel facility printNodeOrder id=${facility.ID} ${printNodeOrder.ID}`)),
      catchError(this.handleError<any>(`createShippingLabel id=${facility.ID} ${printNodeOrder.ID}`))
    );
  }

  createFreightAddressSheets(facility: Facility, printNodeOrder: PrintNodeOrder, printer: string ): Observable<User> {
    const url = `${environment.apiBaseURL}shippinglabel/freightaddresssheets/${facility.ID}/${printNodeOrder.ID}/${printer}`;
    this.messageService.add(`ShippingService: createShippingLabel facility printNodeOrder id=${facility.ID} ${printNodeOrder.ID}`);
    return this.http.put(url, undefined, this.startupService.getHttpOptions()).pipe(
      tap(_ => this.log(`createShippingLabel facility printNodeOrder id=${facility.ID} ${printNodeOrder.ID}`)),
      catchError(this.handleError<any>(`createShippingLabel id=${facility.ID} ${printNodeOrder.ID}`))
    );
  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error, operation); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  private log(message: string) {
    this.messageService.add('UserService: ' + message);
  }

  reset (filter: string = '') {
  }

}
